import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  RrcCompanyProfileInspector,
  RrcCompanyProfilesPage,
} from '@ots-frontend/ots-ui-tw';
export const RrcCompanyProfileKeyProfilePageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcCompanyProfileKeyProfilePage
      profileKey={params.get('key') ?? undefined}
      tenantCode={params.get('tenantCode') ?? undefined}
    />
  );
};
export const RrcCompanyProfileKeyProfilePage = ({
  profileKey,
  tenantCode,
}: {
  profileKey?: string;
  tenantCode?: string;
}) => {
  const navigate = useNavigate();
  return (
    <RrcCompanyProfileInspector
      profileKey={profileKey}
      tenantCode={tenantCode}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
export const RrcCompanyProfilesPageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcCompanyProfilesPage companyId={params.get('companyId') ?? undefined} />
  );
};
